export function toApiNullablePhoneNumber(phone: string | null): string | null {
  return !phone || phone.length <= 2 ? null : phone;
}

export function fromApiNullablePhoneNumber(phone: string | null): string {
  return phone ?? '';
}
